import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Si une ancre est présente dans l'URL, ne pas forcer le scroll
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
            return;
        }

        // Sinon, on scrolle en haut de la page
        window.scrollTo(0, 0);
    }, [pathname, hash]);
};

export default useScrollToTop;
